import { render, staticRenderFns } from "./SupplierAddNew.vue?vue&type=template&id=04b4b836&"
import script from "./SupplierAddNew.vue?vue&type=script&lang=js&"
export * from "./SupplierAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports